module.exports = __webpack_public_path__ + "static/media/smile.e2b93974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smile.png
// module id = 3974
// module chunks = 0